import { appStore } from "@/store/jotaiStore";
import type { DailyCall } from "@daily-co/daily-js";
import { DailyProvider } from "@daily-co/daily-react";
import { useAtom } from "jotai";
import { confirmationOpenAtom } from "../atoms/videoCallAtoms";
import type { TranslatorOption } from "../utils/translatorOptions";
import { CallPanel } from "./CallPanel";
import { Tray } from "./Tray";
import { VideoCallModalConfirmation } from "./VideoCallModalConfirmation";

interface DailyCallContainerProps {
  callObject: DailyCall | null;
  leaveCall: () => void;
  addTranslator: (option?: TranslatorOption) => void;
  removeTranslator: () => void;
  useEventHandling?: () => void;
  useErrorHandling?: () => void;
}

export const DailyCallContainer = ({
  callObject,
  leaveCall,
  addTranslator,
  removeTranslator,
  useEventHandling,
  useErrorHandling,
}: DailyCallContainerProps) => {
  const [confirmationOpen, setConfirmationOpen] = useAtom(confirmationOpenAtom);
  return (
    <div className="w-full h-[40%] bg-white">
      <DailyProvider callObject={callObject} jotaiStore={appStore}>
        <CallPanel
          useEventHandling={useEventHandling}
          useErrorHandling={useErrorHandling}
        />
        <Tray
          leaveCall={leaveCall}
          addTranslator={addTranslator}
          removeTranslator={removeTranslator}
        />
      </DailyProvider>
      <VideoCallModalConfirmation
        isOpen={confirmationOpen}
        onOpenChange={setConfirmationOpen}
      />
    </div>
  );
};
